/**
 * Parametry wyszukiwania strukturalnego Nominatim.
 * @see https://nominatim.org/release-docs/latest/api/Search/
 */
export function buildNominatimSearchParams({country, city, streetName, streetNumber, postalCode, houseNumber}) {
    const params = {};
    const trim = (v) => (v != null ? String(v).trim() : '');

    const countryVal = trim(country);
    const cityVal = trim(city);
    const postalVal = trim(postalCode);
    const streetVal = trim(streetName);
    const numberVal = trim(streetNumber);
    const aptVal = trim(houseNumber);

    if (countryVal) {
        params.country = countryVal;
    }
    if (cityVal) {
        params.city = cityVal;
    }
    if (postalVal) {
        params.postalcode = postalVal;
    }

    let street = streetVal;
    if (numberVal) {
        street = street ? `${street} ${numberVal}` : numberVal;
    }
    if (aptVal) {
        street = street ? `${street}/${aptVal}` : aptVal;
    }
    if (street) {
        params.street = street;
    }

    return params;
}

export function nominatimParamsToQueryString(params) {
    return Object.entries(params)
        .filter(([, value]) => value != null && String(value).trim() !== '')
        .map(([key, value]) => `${key}=${encodeURIComponent(String(value).trim())}`)
        .join('&');
}
